import React, { Component } from "react";
import { Div, Text, Row, Col, Image } from "atomize";
import { Link, graphql } from "gatsby";
import CustomContainer from "../common/CustomContainer";

import {
  Player,
  ControlBar,
  CurrentTimeDisplay,
  TimeDivider,
  VolumeMenuButton,
} from "video-react";
import AnimateLink from "../common/AnimateLink";

const fullVideoParams = {
  fluid: false,
  playsInline: true,
  autoPlay: false,
  isFullscreen: true,
};

class HowSlide extends Component {
  videoRef = React.createRef();

  state = {
    count: 0,
  };

  componentDidMount() {
    this.videoRef.current.subscribeToStateChange(this.handleChange.bind(this));
  }

  handleChange = (state, prevState) => {
    if (
      localStorage.getItem("modalState") === "true" ||
      localStorage.getItem("modalState") === "false"
    ) {
      localStorage.removeItem("autoplayCount");
    } else {
      const locStorageVal = parseInt(localStorage.getItem("autoplayCount"));
      let autoplayCount = locStorageVal ? locStorageVal : 0;
      if (autoplayCount === 2) {
        // this.props.modalState(true);
        localStorage.setItem("autoplayCount", 4);
        autoplayCount = parseInt(localStorage.getItem("autoplayCount"));
      }
      localStorage.setItem("autoplayCount", autoplayCount);
    }
    if (state.ended === true && prevState.ended === false) {
      this.props.swiper.slideNext();
      var count = parseInt(localStorage.getItem("autoplayCount"));
      localStorage.setItem("autoplayCount", ++count);
    }

    // Video Swiper Height
    const height = document.querySelector(".video-slider-wrapper").clientHeight;
    // console.log(height);

    if (state.isFullscreen === true && prevState.isFullscreen === false) {
      document.querySelector(".video-slider-wrapper").style.height = `${height +
        144}px`;
    }
    if (state.isFullscreen === false && prevState.isFullscreen === true) {
      document.querySelector(".video-slider-wrapper").style.height = `${height -
        144}px`;
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.currentSlide === this.props.index &&
      this.props.clicked === true
    ) {
      this.videoRef.current.play();
    } else {
      this.videoRef.current.pause();
    }
    if (this.props.pause) {
      this.videoRef.current.pause();
    }
  }

  render() {
    const { clicked, content, swiper, ...rest } = this.props;
    return (
      <Div className="how-video-slide" h="100%" pos="relative">
        <Player
          {...fullVideoParams}
          ref={this.videoRef}
          poster={content.image.file.url}
          className="how-video"
        >
          <source src={content.video.file.url} />
          <ControlBar>
            <CurrentTimeDisplay order={4.1} />
            <TimeDivider order={4.2} />
            <VolumeMenuButton order={8} />
          </ControlBar>
        </Player>
      </Div>
    );
  }
}

export default HowSlide;
